class FaqWrapper extends HTMLElement {
    search;
    faqTitle;
    results;
    categories;
    constructor() {
        super();
        this.search = this.querySelector('#faq_search');
        this.faqTitle = this.querySelector('.faq_title');
        this.results = this.querySelector('.faq_results-wrapper');
        this.categories = this.querySelectorAll('.faq_category');
        this.categories.forEach(category => { category.addEventListener('click', this.changeCategory.bind(this)); });
        this.search.addEventListener('change', this.handleSearch.bind(this));
        this.search.addEventListener('input', this.handleSearch.bind(this));
    }
    changeCategory(e) {
        const category = e.target.closest('.faq_category').dataset.category;
        this.faqTitle.innerHTML = category;
        this.querySelector('.faq_category.selected').classList.remove('selected');
        this.querySelector('.faq_category[data-category="' + category + '"]').classList.add('selected');
        this.querySelector('.faq_elements-wrapper faq-component:not([hidden])').setAttribute('hidden', '');
        this.querySelector('.faq_elements-wrapper faq-component[data-category="' + category + '"]').removeAttribute('hidden');
        const top = this.querySelector('.faq_elements-wrapper').offsetTop;
        if (top) window.scrollTo(0, top);
    }
    handleSearch() {
        const value = this.search.value.toLowerCase();
        if (value === '') {
            this.results.innerHTML = '';
            this.dataset.mode = 'faq';
            return;
        }
        this.dataset.mode = 'search';
        const filtered = window.theme.faq.filter((el) => el.text.includes(value));
        if (filtered.length === 0) {
            this.results.innerHTML = `<p class="h3">No information found.<p>
      <p>Please email us your issue so we can help you with your problem.</p>`;
            return;
        }
        let html = '<faq-component>';
        filtered.forEach((el) => {
            html += `<div>
      <dt aria-expanded="false">${el.question}</dt>
      <dd>${el.answer}</dd>
    </div>`;
        });
        html += '</faq-component>';
        this.results.innerHTML = html;
    }
}
customElements.define('faq-wrapper', FaqWrapper);